import { LProgressCircle } from "../../../common/components/LProgressCircle";
import { LSubTitle } from "../../../common/components/LSubtitle";
import { LTitle } from "../../../common/components/LTitle";
import { useCountDown } from "../../../common/helpers/countHelper";
import { Colors } from "../../../styles/colors";
import { AssessmentShell } from "../components/AssessmentShell";
import { useNavigate } from "react-router-dom";
import { NavItems } from "../../../common/helpers/navigation";
import { useAppSelector } from "../../../app/hooks";
import { Translate } from "react-i18nify";

export const AssessmentDelayedRecall = (): JSX.Element => {
    const navigate = useNavigate();

    const handleOnDone = (): void => {
        navigate(NavItems.Assessments.AssessmentFreeRecall.path);
    };

    const delayTime = useAppSelector((x) => x.globalSettings.delayTime);

    const [counter] = useCountDown({ from: delayTime, onDone: handleOnDone });

    const progress = Math.floor(((delayTime - counter) * 100) / delayTime);

    const time = new Date((delayTime - counter) * 1000).toISOString().slice(14, 19);

    return (
        <div style={{ backgroundColor: Colors.primaryBlue }}>
            <AssessmentShell>
                <div className="assessment-timer" style={{ position: "absolute", right: "2%", top: "5%" }}>
                    <LProgressCircle progress={progress} text={time} />
                </div>
                <div className="is-flex is-flex-direction-column">
                    <LTitle overrideSize="5rem" theme="dark">
                        <Translate value="assessments.taskCompleted" />
                    </LTitle>
                    <LSubTitle theme="dark">
                        <Translate value="assessments.seeGuidance" />
                    </LSubTitle>
                </div>
            </AssessmentShell>
        </div>
    );
};
